import * as React from 'react';

function SvgAudioLevelIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M12.5 5a.625.625 0 00-.625.625v13.75a.625.625 0 001.25 0V5.625A.625.625 0 0012.5 5zM10 6.25a.625.625 0 00-.625.625v11.25a.625.625 0 101.25 0V6.875A.625.625 0 0010 6.25zM7.5 8.75a.625.625 0 00-.625.625v6.25a.625.625 0 101.25 0v-6.25A.625.625 0 007.5 8.75zM5.625 11.25a.625.625 0 00-.625.625v1.25a.625.625 0 001.25 0v-1.25a.625.625 0 00-.625-.625zM15 6.25a.625.625 0 00-.625.625v11.25a.625.625 0 101.25 0V6.875A.625.625 0 0015 6.25zM17.5 8.75a.625.625 0 00-.625.625v6.25a.624.624 0 101.25 0v-6.25a.625.625 0 00-.625-.625zM19.375 11.25a.625.625 0 00-.625.625v1.25a.625.625 0 101.25 0v-1.25a.625.625 0 00-.625-.625z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SvgAudioLevelIcon;
